export const InvoicesTypes = {
  IQueryInvoicesService: Symbol("IQueryInvoicesService"),
  IDownloadPDFInvoicesService: Symbol("IDownloadPDFInvoicesService"),
  IDownloadAllReportTitlesService: Symbol("IDownloadAllReportTitlesService"),
};
